export default __webpack_public_path__ + "static/media/Meme_hero.275c1ba2.jpg";